export const TOP_MENU = [
  {
    id: 0,
    text: 'Reiknivél',
    url: '/calculation',
    exact: false
  },
  {
    id: 1,
    text: 'Claim Tracker',
    url: '/claimtracker',
    exact: false
  }
];



// WEBPACK FOOTER //
// ./src/constants/products.js